import { defineRelations } from "@-/com.npmjs.drizzle-orm";
import * as actorSchema from "#schema";

// Relations into `crudTable` rows include `where: { deletedAt: { isNull: true } }`
// so nested `with: { ... }` excludes tombstoned targets. Top-level reads on those
// tables get the same filter via `wrap-actor-database.ts`.
//
// Per-card actor overlays live on `userCard` (`skippedAt`, `fsrsCardId`,
// `startedStudyingAt`). Content identity and meaning mnemonics are on `userGraphemeMeaningCard` /
// `userGraphemePronunciationCard` (`grapheme`, `description` on meaning, plus `pinyin`
// for pronunciation). Those overlays carry their own `deletedAt` and are tombstoned
// together with their `userCard` on reset.
export const actorRelations = defineRelations(actorSchema, (r) => ({
  collection: {
    collectionMorphemes: r.many.collectionMorpheme({
      from: r.collection.id,
      to: r.collectionMorpheme.collectionId,
      where: { deletedAt: { isNull: true } },
    }),
    user: r.one.user({
      from: r.collection.userId,
      optional: false,
      to: r.user.id,
      where: { deletedAt: { isNull: true } },
    }),
  },
  collectionMorpheme: {
    collection: r.one.collection({
      from: r.collectionMorpheme.collectionId,
      optional: false,
      to: r.collection.id,
      where: { deletedAt: { isNull: true } },
    }),
  },
  fsrsCard: {
    userCard: r.one.userCard({
      from: r.fsrsCard.id,
      to: r.userCard.fsrsCardId,
      where: { deletedAt: { isNull: true } },
    }),
  },
  fsrsCardReviewLog: {
    userCardReview: r.one.userCardReview({
      from: r.fsrsCardReviewLog.id,
      to: r.userCardReview.fsrsCardReviewLogId,
      where: { deletedAt: { isNull: true } },
    }),
  },
  user: {
    collections: r.many.collection({
      from: r.user.id,
      to: r.collection.userId,
      where: { deletedAt: { isNull: true } },
    }),
  },
  userCard: {
    fsrsCard: r.one.fsrsCard({
      from: r.userCard.fsrsCardId,
      optional: true,
      to: r.fsrsCard.id,
      where: { deletedAt: { isNull: true } },
    }),
    userCardReviews: r.many.userCardReview({
      from: r.userCard.id,
      to: r.userCardReview.cardId,
      where: { deletedAt: { isNull: true } },
    }),
    userGraphemeMeaningCard: r.one.userGraphemeMeaningCard({
      from: r.userCard.id,
      optional: true,
      to: r.userGraphemeMeaningCard.userCardId,
      where: { deletedAt: { isNull: true } },
    }),
    userGraphemePronunciationCard: r.one.userGraphemePronunciationCard({
      from: r.userCard.id,
      optional: true,
      to: r.userGraphemePronunciationCard.userCardId,
      where: { deletedAt: { isNull: true } },
    }),
    userQuizCard: r.one.userQuizCard({
      from: r.userCard.id,
      optional: true,
      to: r.userQuizCard.userCardId,
      where: { deletedAt: { isNull: true } },
    }),
    userWordSentenceCard: r.one.userWordSentenceCard({
      from: r.userCard.id,
      optional: true,
      to: r.userWordSentenceCard.userCardId,
      where: { deletedAt: { isNull: true } },
    }),
  },
  userCardReview: {
    fsrsCardReviewLog: r.one.fsrsCardReviewLog({
      from: r.userCardReview.fsrsCardReviewLogId,
      to: r.fsrsCardReviewLog.id,
      where: { deletedAt: { isNull: true } },
    }),
    userCard: r.one.userCard({
      from: r.userCardReview.cardId,
      optional: false,
      to: r.userCard.id,
      where: { deletedAt: { isNull: true } },
    }),
  },
  userGraphemeMeaningCard: {
    userCard: r.one.userCard({
      from: r.userGraphemeMeaningCard.userCardId,
      optional: false,
      to: r.userCard.id,
      where: { deletedAt: { isNull: true } },
    }),
  },
  userGraphemePronunciationCard: {
    userCard: r.one.userCard({
      from: r.userGraphemePronunciationCard.userCardId,
      optional: false,
      to: r.userCard.id,
      where: { deletedAt: { isNull: true } },
    }),
  },
  userQuizCard: {
    userCard: r.one.userCard({
      from: r.userQuizCard.userCardId,
      optional: false,
      to: r.userCard.id,
      where: { deletedAt: { isNull: true } },
    }),
  },
  userWordSentenceCard: {
    userCard: r.one.userCard({
      from: r.userWordSentenceCard.userCardId,
      optional: false,
      to: r.userCard.id,
      where: { deletedAt: { isNull: true } },
    }),
  },
}));
